import { render, staticRenderFns } from "./addOpenclass.vue?vue&type=template&id=5b679e16&"
import script from "./addOpenclass.vue?vue&type=script&lang=js&"
export * from "./addOpenclass.vue?vue&type=script&lang=js&"
import style0 from "./addOpenclass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports